import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const RemoveWorkspaceCollaboratorFromBoardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveWorkspaceCollaboratorFromBoard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idMember"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMemberFromBoard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idBoard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}}},{"kind":"Argument","name":{"kind":"Name","value":"idMember"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idMember"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"RemoveWorkspaceCollaboratorFromBoard","document":RemoveWorkspaceCollaboratorFromBoardDocument}} as const;
export type RemoveWorkspaceCollaboratorFromBoardMutationVariables = Types.Exact<{
  idBoard: Types.Scalars['ID']['input'];
  idMember: Types.Scalars['ID']['input'];
  traceId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type RemoveWorkspaceCollaboratorFromBoardMutation = (
  { __typename: 'Mutation' }
  & { removeMemberFromBoard?: Types.Maybe<(
    { __typename: 'Board_Member_DeleteResponse' }
    & Pick<Types.Board_Member_DeleteResponse, 'success'>
  )> }
);

export type RemoveWorkspaceCollaboratorFromBoardMutationFn =
  Apollo.MutationFunction<
    RemoveWorkspaceCollaboratorFromBoardMutation,
    RemoveWorkspaceCollaboratorFromBoardMutationVariables
  >;

/**
 * __useRemoveWorkspaceCollaboratorFromBoardMutation__
 *
 * To run a mutation, you first call `useRemoveWorkspaceCollaboratorFromBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkspaceCollaboratorFromBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkspaceCollaboratorFromBoardMutation, { data, loading, error }] = useRemoveWorkspaceCollaboratorFromBoardMutation({
 *   variables: {
 *      idBoard: // value for 'idBoard'
 *      idMember: // value for 'idMember'
 *      traceId: // value for 'traceId'
 *   },
 * });
 */
export function useRemoveWorkspaceCollaboratorFromBoardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveWorkspaceCollaboratorFromBoardMutation,
    RemoveWorkspaceCollaboratorFromBoardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveWorkspaceCollaboratorFromBoardMutation,
    RemoveWorkspaceCollaboratorFromBoardMutationVariables
  >(RemoveWorkspaceCollaboratorFromBoardDocument, options);
}
export type RemoveWorkspaceCollaboratorFromBoardMutationHookResult = ReturnType<
  typeof useRemoveWorkspaceCollaboratorFromBoardMutation
>;
export type RemoveWorkspaceCollaboratorFromBoardMutationResult =
  Apollo.MutationResult<RemoveWorkspaceCollaboratorFromBoardMutation>;
export type RemoveWorkspaceCollaboratorFromBoardMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveWorkspaceCollaboratorFromBoardMutation,
    RemoveWorkspaceCollaboratorFromBoardMutationVariables
  >;
